module.exports = __webpack_public_path__ + "img/icon_map_199_on_100.45250f14.png";